function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, forwardRef } from "react";
import { Table, Container } from "react-bootstrap";
import { Row, Col, Image, Statistic, Space, DatePicker, Modal, Button, notification } from "antd";
import Moment from "react-moment";
import moment from "moment";
import Common from "./includes/Common";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import DocumentHeader from "./DocumentHeader";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var confirm = Modal.confirm;
var DisplaySalarySheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var sheet = _ref.sheet,
      handler = _ref.handler;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      totalSalaryAmount = _useState2[0],
      setTotalSalaryAmount = _useState2[1];

  var _useState3 = useState(moment()),
      _useState4 = _slicedToArray(_useState3, 2),
      workPeriod = _useState4[0],
      setWorkPeriod = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataLoading = _useState6[0],
      setIsDataLoading = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      idList = _useState8[0],
      setIdList = _useState8[1];

  var mar = ["JANVIER", "FEVRIER", "MARS", "AVRIL", "MAI", "JUIN", "JUILLET", "AOUT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DECEMBRE"];
  useEffect(function () {
    sheet.employee_salary_sheets.forEach(function (e) {
      setTotalSalaryAmount(sheet.total);
      setIdList(function (prev) {
        return [].concat(_toConsumableArray(prev), [e.employee.id]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    id: "printable",
    style: {
      padding: "25px",
      textAlign: "center"
    },
    children: [/*#__PURE__*/_jsx(DocumentHeader, {
      title: "ETAT DES SALAIRES"
    }), /*#__PURE__*/_jsx(Row, {
      gutter: 16,
      children: /*#__PURE__*/_jsx(Col, {
        lg: 14,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            padding: "18px",
            color: "#EEE",
            background: "#95302D",
            clear: "both"
          },
          children: [/*#__PURE__*/_jsx("h2", {
            children: /*#__PURE__*/_jsx("b", {})
          }), /*#__PURE__*/_jsx("p", {
            children: mar[sheet.month] + " " + sheet.year
          })]
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
      gutter: 6,
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 8,
        md: 8,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "12px",
            borderRadius: "6px",
            background: "#E8D084",
            textAlign: "center"
          },
          children: /*#__PURE__*/_jsx("h2", {
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(Statistic, {
                title: "Montant total",
                value: totalSalaryAmount,
                prefix: "GNF"
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 16,
        md: 16,
        children: /*#__PURE__*/_jsxs(Table, {
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("th", {
                children: "Ref."
              }), /*#__PURE__*/_jsx("th", {
                children: "Nom"
              }), /*#__PURE__*/_jsx("th", {
                children: "Fonction"
              }), /*#__PURE__*/_jsx("th", {
                children: "Montant (Gnf)"
              })]
            })
          }), /*#__PURE__*/_jsx("tbody", {
            children: sheet.employee_salary_sheets && sheet.employee_salary_sheets.map(function (e) {
              return /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsxs("td", {
                  children: ["#", e.id]
                }), /*#__PURE__*/_jsx("td", {
                  children: "".concat(e.employee.firstname, " ").concat(e.employee.lastname)
                }), /*#__PURE__*/_jsx("td", {
                  children: e.employee.job
                }), /*#__PURE__*/_jsx("td", {
                  children: e.salary.toLocaleString("Fr")
                })]
              }, e.id);
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default DisplaySalarySheet;